const CHUNK_LOAD_ERROR =
  /ChunkLoadError|Loading chunk [^\s]+ failed|dynamically imported module|Importing a module script failed/i;

/** A lazy chunk that failed to load — the usual sign that a deploy replaced the chunks. */
export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? `${error.name} ${error.message}`
      : String((error as { message?: string })?.message ?? error ?? '');

  return CHUNK_LOAD_ERROR.test(message);
}
